const IconInfo = () => (
    <img width={12} src={require(`./info.webp`).default} alt="imagen" />
)

const IconCheck = () => (<img width={15} src={require(`./check.webp`).default} alt="imagen" />)

const IconVisaMastercard = () =>  (<img className="ml-10" width='30%' src={require(`./visaMastercard.webp`).default} alt="imagen" />)

const IconHappy = () =>  (<img width={80} src={require(`./happy.webp`).default} alt="imagen" />)

const IconSad = () =>  (<img width={80} src={require(`./sad.webp`).default} alt="imagen" />)

const IconWarning = () =>  (<img width={80} src={require(`./warning.webp`).default} alt="imagen" />)

const IconMail = () => (
    <img width={60} src={require(`./correo.webp`).default} alt="imagen" />
)

export {
    IconInfo,
    IconCheck,
    IconVisaMastercard,
    IconHappy,
    IconMail,
    IconWarning,
    IconSad
}